import { normalizeSuiAddress } from "@act/shared";

/**
 * "Link Sui" (DR-0053, amended for ACT HQ t-706): which of the addresses a Sui
 * app shares can still be linked. An app that has already let ACT in answers
 * "connect" with the address it shared last time, so a second Link Sui offered
 * that same address again. Drop every address the account already has: its
 * linked ones and its Account ID.
 */
export function linkableAccounts<A extends { address: string }>(
  shared: readonly A[],
  have: ReadonlyArray<string | null | undefined>,
): A[] {
  const known = new Set<string>();
  for (const address of have) {
    const normal = address ? normalizeSuiAddress(address) : null;
    if (normal) known.add(normal);
  }
  return shared.filter((account) => {
    const normal = normalizeSuiAddress(account.address);
    return normal !== null && !known.has(normal);
  });
}
